import { render, staticRenderFns } from "./SleevesSidebar.vue?vue&type=template&id=f52359c2&scoped=true&"
import script from "./SleevesSidebar.vue?vue&type=script&lang=js&"
export * from "./SleevesSidebar.vue?vue&type=script&lang=js&"
import style0 from "./SleevesSidebar.vue?vue&type=style&index=0&id=f52359c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52359c2",
  null
  
)

export default component.exports